import React from "react";
import { Modal, Button, Card, Table, Alert } from "react-bootstrap";

function DailyOrderModal({
  responseCaseStatus,
  errorString,
  submitError,
  show,
  handleClose,
}) {
  // If there's an error in the API response, display the error message
  if (submitError) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Button className="btn-secondary">X</Button>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">
            {responseCaseStatus?.error ||
              "An error occurred. Please try again."}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's an error message in the API response, display the error message
  if (errorString !== "") {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorString}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's no data, do not render anything
  if (!responseCaseStatus || !responseCaseStatus.data) return null;

  const renderCaseDetails = (caseDetail) => (
    <Card className="mb-3" key={caseDetail.case_no}>
      <Card.Body>
        <Card.Title>{caseDetail.case_title}</Card.Title>
        <Card.Text>
          <table className="mt-4 table table-striped table-bordered table-hover case-table">
            <tr>
              <td>
                <span>Case No:</span>
              </td>
              <td> {caseDetail.case_no}</td>
            </tr>
            <tr>
              <td>
                <span>Status:</span>{" "}
              </td>
              <td>{caseDetail.c_status}</td>
            </tr>
            <tr>
              <td>
                <span>Filing No:</span>{" "}
              </td>
              <td>{caseDetail.filing_no}</td>
            </tr>
            <tr>
              <td>
                <span>Date of Filing:</span>
              </td>
              <td> {caseDetail.date_of_filing}</td>
            </tr>
            <tr>
              <td>
                <span>Case Registered Date:</span>{" "}
              </td>
              <td>{caseDetail.case_registered_date}</td>
            </tr>
            <tr>
              <td>
                <span>Petitioner Advocate:</span>{" "}
              </td>
              <td>{caseDetail.pet_adv_name}</td>
            </tr>
            <tr>
              <td>
                <span>Petitioner Names:</span>{" "}
              </td>
              <td>{caseDetail.pet_names}</td>
            </tr>
            <tr>
              <td>
                <span>Respondent Names:</span>{" "}
              </td>
              <td>{caseDetail.res_names}</td>
            </tr>
            <tr>
              <td>
                <span>Respondent Advocate:</span>{" "}
              </td>
              <td>{caseDetail.res_adv_name || "N/A"}</td>
            </tr>
            <tr>
              <td>
                {" "}
                <span>E-Reference No:</span>{" "}
              </td>
              <td>{caseDetail.e_reference_no}</td>
            </tr>
          </table>
        </Card.Text>
      </Card.Body>
    </Card>
  );

  const renderProceedings = (proceeding, index) => {
    // Only render rows where order_type is "J"
    // if (proceeding.order_type === "J") {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{proceeding.listing_date}</td>
          <td>{proceeding.next_listing_date}</td>
          <td>{proceeding.listing_purpose}</td>
          <td>{proceeding.today_action}</td>
          <td>{proceeding.remarks}</td>
          <td>
            {proceeding.file_name ? (
              <a
                href={`${process.env.REACT_APP_API_FILE_URL}/displayOrder/${proceeding.filing_no}/${proceeding.hash_filename}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Order
              </a>
            ) : (
              "N/A"
            )}
          </td>
        </tr>
      );
    // }
    // return null; // If order_type is not "J", do not render anything
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header onClick={handleClose}>
        <Modal.Title>Daily Order Details</Modal.Title>
        <Button className="btn-secondary">X</Button>
      </Modal.Header>
      <Modal.Body>
        {/* {responseCaseStatus.data.map(renderCaseDetails)} */}

        {responseCaseStatus.allProceeding &&
        responseCaseStatus.allProceeding.length > 0 ? (
          <>
            <h5 className="mt-4">Proceedings:</h5>
            <table className="table table-striped common-table modal-custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Listing Date</th>
                  <th>Next Listing Date</th>
                  <th>Listing Purpose</th>
                  <th>Today's Action</th>
                  <th>Remarks</th>
                  <th>Order File</th>
                </tr>
              </thead>
              <tbody>
                {responseCaseStatus.allProceeding.map(renderProceedings)}
              </tbody>
            </table>
          </>
        ) : (
          <p>No Data available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DailyOrderModal;
